import axios from 'axios';
import { useRef, useState, useCallback, useEffect } from 'react';
var cancelMsg = 'Operation canceled by the user.';
var useSearch = function useSearch(searchConfig, context) {
  var _ref = searchConfig || {},
    onSearch = _ref.search,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'GET' : _ref$method,
    url = _ref.url,
    _ref$queryParam = _ref.queryParam,
    queryParam = _ref$queryParam === void 0 ? 'q' : _ref$queryParam,
    _ref$withCredentials = _ref.withCredentials,
    withCredentials = _ref$withCredentials === void 0 ? false : _ref$withCredentials;
  var unmounted = useRef(false);
  var source = useRef();
  var _useState = useState(null),
    searchResult = _useState[0],
    setSearchResult = _useState[1];
  var search = useCallback(function (searchTerm) {
    if (onSearch) {
      setSearchResult(onSearch(searchTerm, context));
    } else if (url) {
      var _params;
      if (source.current) {
        source.current.cancel(cancelMsg);
      }
      var tokenSource = axios.CancelToken.source();
      source.current = tokenSource;
      axios.request({
        url: url,
        method: method,
        params: (_params = {}, _params[queryParam] = searchTerm, _params),
        withCredentials: withCredentials,
        cancelToken: tokenSource.token
      }).then(function (_ref2) {
        var data = _ref2.data;
        if (!unmounted.current) {
          setSearchResult(data);
        }
        return data;
      }).catch(function (error) {
        console.error(error);
        if (!unmounted.current) {
          setSearchResult(null);
        }
      });
    }
  }, [onSearch, url, context, method, queryParam, withCredentials]);
  useEffect(function () {
    return function () {
      unmounted.current = true;
      if (source.current) {
        source.current.cancel(cancelMsg);
      }
    };
  }, [source]);
  return {
    search: search,
    searchResult: searchResult
  };
};
export { useSearch };